module.exports = __webpack_public_path__ + "static/media/join.3c98cea2.png";